<div class='sideBarContent content loading-spinner' *ngIf="isLoading"></div>
<div class="sideBarContent content" *ngIf="!isLoading">
  <irb-editor-sidebar-banner
  [accordian]="accordian"
  [showUnsavedChangesWarning]="showUnsavedChangesWarning"
  [isModified]="isModified"
  [isValid]="isValid"
  [hasPendingFunction]="hasPendingFunction"
  [slot]="slot"
  (save)="save()"
  (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="'Edit Multiple Portfolios'" [tooltipRequiresTruncation]="true">Edit Multiple Portfolios</span></irb-editor-sidebar-banner>
  <div class="body" [style.height]="bodyHeight" #body>
      <div class="block  status-message-model warning" *ngIf="data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Paused for review'">
        <div>
            The assigned model has been changed by the model provider. Automated rebalancing will be paused until you review and resume rebalancing or assign these portfolios to a different model.
        </div>
        <div>
            <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model</a>
        </div>
      </div>
      <div class="block  status-message-model warning" *ngIf="data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Not allowed'">
        <div>
            The assigned model does not currently allow automated rebalancing. You'll need to edit the model settings to allow automated rebalancing with this model.
        </div>
        <div>
            <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model</a>
        </div>
      </div>
      <div class="dblock editorDisplayBanner">
        <div class="block bold">{{multiplePortfolioEditRequest.portfolioCount}} Portfolios</div>
        <div><a (click)="showPortfolioMultieditView()">View portfolios</a></div>
      </div>

      <mat-accordion #accordian="matAccordion" [multi]="true">
          <mat-expansion-panel id="SETTINGS" [expanded]="ies.getDefaultExpansionState('SETTINGS')"
           (opened)="ies.updateExpansionStateOpenTriggers('SETTINGS','opened')"
           (closed)="ies.updateExpansionStateOpenTriggers('SETTINGS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Model Assignments <img *ngIf="data.isAutoRebalEnabled && selectedModel?.allowAutoRebalOnModelUpdate === 'Paused for review'"
                  class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-left: 12px;">
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-com-assignments *ngIf="data" [(data)]="data"  [parentObj]="this"
                [selectedModel]="selectedModel"
                (selectedModelChange)="onSelectedModelChange($event)"
                (change)="onInputChange()" [multipleporfolios]="true"></irb-com-assignments>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="!isUnAuthorized" id="CUSTOM_LABELS" [expanded]="ies.getDefaultExpansionState('CUSTOM_LABELS')"
           (opened)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('CUSTOM_LABELS','opened') : ies.updateExpansionState('CUSTOM_LABELS','opened')"
           (closed)="collapseForOpenTriggers? ies.updateExpansionStateOpenTriggers('CUSTOM_LABELS','closed') : ies.updateExpansionState('CUSTOM_LABELS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Custom Labels
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-com-custom-labels *ngIf="data && isGlobalSettings" [(data)]="data" 
                [multipleporfolios]="true" [selectedPortfolioCount]="multiplePortfolioEditRequest.portfolioCount" 
                [globalSettings]="globalSettings" (change)="onInputChange()"></irb-com-custom-labels>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel id="GAINS_MANAGEMENT" [expanded]="ies.getDefaultExpansionState('GAINS_MANAGEMENT')"
                               (opened)="ies.updateExpansionStateOpenTriggers('GAINS_MANAGEMENT','opened')"
                               (closed)="ies.updateExpansionStateOpenTriggers('GAINS_MANAGEMENT','closed')">
              <mat-expansion-panel-header>
                  <mat-panel-title>
                      Gains Management
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                  <irb-com-gains *ngIf="data && isGlobalSettings" [(data)]="data" [globalSettings]="globalSettings" [(isValid)]="isGainsManagementValid" [multipleporfolios]="true" (change)="onInputChange()"></irb-com-gains>
              </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="isAutoRebalanceEnabled" id="AUTOMATED_REBALANCING" [expanded]="ies.getDefaultExpansionState('AUTOMATED_REBALANCING')"
                               (opened)="ies.updateExpansionStateOpenTriggers('AUTOMATED_REBALANCING','opened')"
                               (closed)="ies.updateExpansionStateOpenTriggers('AUTOMATED_REBALANCING','closed')">
              <mat-expansion-panel-header>
                  <mat-panel-title>
                      Automated Rebalancing <img *ngIf="data.isAutoRebalEnabled && (selectedModel?.allowAutoRebalOnModelUpdate === 'Paused for review' || selectedModel?.allowAutoRebalOnModelUpdate === 'Not allowed')"
                        class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-left: 12px;">
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                  <irb-com-automated-rebalancing *ngIf="data" [(data)]="autoRebalanceData"
                  [selectedModel]="selectedModel"
                  [isTLHSetInGlobal]="isTLHSetInGlobal" (change)="onAutoRebalanceChange()" [multipleporfolios]="true" [selectedPortfolios]="multiplePortfolioEditRequest"></irb-com-automated-rebalancing>
              </ng-template>
          </mat-expansion-panel>
      </mat-accordion>
  </div>
</div>
